import { render, staticRenderFns } from "./aStaffList.vue?vue&type=template&id=1836eef6&scoped=true"
import script from "./aStaffList.vue?vue&type=script&lang=js"
export * from "./aStaffList.vue?vue&type=script&lang=js"
import style0 from "./aStaffList.vue?vue&type=style&index=0&id=1836eef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1836eef6",
  null
  
)

export default component.exports